// import React from "react";
// import flatlay from "../../Assets/services-flatlay.jpg";

// const conditions = [
//   "Allergies & sinus",
//   "Anxiety & stress",
//   "Arthritis",
//   "Asthma",
//   "Autoimmune support",
//   "Children's behavior",
//   "Chronic fatigue",
//   "Colic & teething",
//   "Digestive issues",
//   "Eczema & skin",
//   "Fertility",
//   "Headaches & migraines",
//   "Hormonal imbalance",
//   "Insomnia",
//   "Menstrual concerns",
//   "Perimenopause",
//   "Postpartum recovery",
//   "Recurrent infections",
//   "Sleep disturbances",
//   "Thyroid support",
// ];

// function ServicesConditionsSupported() {
//   return (
//     <>
//       <section className="ConditionsSupported_Section">
//         <div className="ConditionsSupported_SectionParent">
//           <div className="ConditionsSupported_Section_ImageDiv animate-top">
//             <img
//               src={flatlay}
//               alt="ConditionsSupported_Section_Imageflatlay"
//               loading="eager"
//               className="ConditionsSupported_Section_Image"
//             />
//           </div>
//           <div className="ConditionsSupported_Section00">
//             <div className="ConditionsSupported_SectionBox animate-top">
//               <p className="ConditionsSupported_Section_Title animate-top">
//                 Conditions Supported
//               </p>
//               <h2 className="ConditionsSupported_Section_Heading animate-top">
//                 Whole-person care for a wide range of concerns.
//               </h2>
//               <p className="ConditionsSupported_Section_Content animate-top">
//                 If you don't see your concern listed, please reach out —
//                 homeopathy heals the person, not just the diagnosis.
//               </p>
//             </div>
//             <ul className="ConditionsSupported_Section_ContentUL">
//               {conditions.map((c) => (
//                 <li
//                   key={c}
//                   className=" ConditionsSupported_Section_ContentLI animate-top"
//                 >
//                   <span className="ConditionsSupported_Section_Content animate-top">
//                     {c}
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

// export default ServicesConditionsSupported;

import React from "react";
import flatlay from "../../Assets/services-flatlay.jpg";

const conditionsData = [
  {
    title: "Pain & Neurological Conditions",
    items: [
      "Headaches and migraines",
      "Sciatica",
      "Brachial neuralgia",
      "Sports injuries and musculoskeletal discomfort",
      "Post-surgical recovery support",
      "Tinnitus",
      "Insomnia and sleep disturbances",
      "Plantar fasciitis and Achilles tendinitis",
      "Back pain",
    ],
  },
  {
    title: "Skin & Hair Conditions",
    items: [
      "Skin conditions",
      "Rosacea",
      "Vitiligo",
      "Warts and corns",
      "Alopecia areata",
      "Abscesses and recurrent skin irritation",
    ],
  },
  {
    title: "Women’s Health",
    items: [
      "Ovarian cysts/fibroids to certain size",
      "Menorrhagia",
      "Metrorrhagia",
      "Amenorrhea",
      "Hormonal imbalance support",
      "Delayed puberty concerns in adolescent girls",
      "Delayed pregnancy/fertility issues",
      "Peri/post menopause issues",
    ],
  },
  {
    title: "Digestive & Metabolic Health",
    items: [
      "Irritable Bowel Syndrome (IBS)",
      "Hemorrhoids",
      "Kidney stones",
      "Digestive discomfort and bloating",
      "Supportive care for diabetes management",
      "High cholesterol",
      "Hypertension (high blood pressure) support",
    ],
  },
  {
    title: "Respiratory & Allergy Conditions",
    items: [
      "Sinusitis",
      "Allergic rhinitis",
      "Hay fever",
      "Asthma support",
      "Seasonal allergy symptoms",
    ],
  },
  {
    title: "Mental & Emotional Wellbeing",
    items: [
      "Anxiety and stress-related symptoms",
      "Depression support",
      "Attention-related challenges (ADHD)",
      "ASD-related supportive care",
      "Emotional imbalance and burnout",
      "Recovery support following intense psychoactive or spiritual experiences",
    ],
  },
  {
    title: "Autoimmune & Chronic Conditions",
    items: [
      "Supportive care for autoimmune disorders",
      "Lyme disease support",
      "Diabetic neuropathy",
      "Chronic inflammatory conditions",
      "Fatigue and constitutional weakness",
    ],
  },
  {
    title: "Other Conditions",
    items: [
      "Fistula",
      "Anemia support",
      "General wellness and constitutional care",
      "Recovery and vitality support",
    ],
  },
  {
    title: "Infant/ Children’s Health: ",
    items: [
      "Colic",
      "Teething discomfort",
      "Reflux / spitting up",
      "Sleep disturbances",
      "Mild diaper rash",
    ],
  },
  {
    title: "Common Childhood Illnesses",
    items: [
      "Colds and coughs",
      "Sore throat",
      "Ear discomfort",
      "Mild fevers",
      "Seasonal allergies",
      "Sinus congestion",
    ],
  },
  {
    title: "Skin Conditions",
    items: ["Mild rashes", "Acne in teens", "Warts"],
  },
  {
    title: "Digestive Issues",
    items: [
      "Constipation",
      "Diarrhea",
      "Gas / bloating",
      "Nausea",
      "Motion sickness",
      "Appetite concerns",
    ],
  },
  {
    title: "Behavioral & Emotional Concerns",
    items: [
      "Anxiety",
      "Irritability",
      "School stress",
      "Sleep anxiety",
      "Nail biting",
      "Attention / focus concerns",
    ],
  },
  {
    title: "Respiratory Concerns",
    items: ["Allergies", "Mild asthma support", "Recurrent colds"],
  },
  {
    title: "Growth & Wellness",
    items: [
      "Immune support",
      "General wellness",
      "Recovery support after illness",
      "Fatigue",
    ],
  },
  {
    title: "Sports & Physical Complaints",
    items: ["Minor bruises", "Muscle soreness", "Injuries", "Minor sprains"],
  },
];

function ServicesConditionsSupported() {
  return (
    <>
      <section className="ConditionsSupported_Section">
        <div className="ConditionsSupported_SectionParent">
          <div className="ConditionsSupported_Section_ImageDiv animate-top">
            <img
              src={flatlay}
              alt="Conditions Supported"
              loading="eager"
              className="ConditionsSupported_Section_Image"
            />
          </div>

          <div className="ConditionsSupported_Section00">
            <div className="ConditionsSupported_SectionBox animate-top">
              <p className="ConditionsSupported_Section_Title animate-top">
                Conditions Homeopathy May Support
              </p>

              <h2 className="ConditionsSupported_Section_Heading animate-top">
                Individualized homeopathic care for wellness, recovery, and
                symptom support.
              </h2>

              <p className="ConditionsSupported_Section_Content animate-top">
                Homeopathy is used as a complementary approach to support
                overall wellness, symptom management, and recovery.
                Individualized therapeutic plans may support the management of a
                broad range of conditions, including, but not limited to, those
                listed below.
              </p>
            </div>

            <div className="ConditionsSupported_Section_Categories">
              {conditionsData.map((section, index) => (
                <div
                  key={index}
                  className="ConditionsSupported_Section_Category animate-top"
                >
                  <h4 className="ConditionsSupported_Section_SubHeading">
                    {section.title}
                  </h4>

                  <ul className="ConditionsSupported_Section_ContentUL">
                    {section.items.map((item, i) => (
                      <li
                        key={i}
                        className="ConditionsSupported_Section_ContentLI animate-top"
                      >
                        <span className="ConditionsSupported_Section_Content00">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* Disclaimer Section */}
            <div className="ConditionsSupported_Section_Disclaimer animate-top">
              <h3 className="ConditionsSupported_Section_SubHeading">
                Professional Disclaimer
              </h3>

              <p className="ConditionsSupported_Section_Content">
                Homeopathy is intended as a complementary and supportive
                wellness approach and is not a substitute for emergency medical
                care, diagnosis, or medically necessary conventional treatment.
                Individual responses to treatment may vary.
                {/* Patients are
                encouraged to consult a qualified healthcare professional
                regarding serious or persistent medical conditions. */}
              </p>
            </div>

            {/* SEO Notes */}
            {/* <div className="ConditionsSupported_Section_Disclaimer animate-top">
              <h3 className="ConditionsSupported_Section_SubHeading">
                Holistic Wellness & Integrative Care
              </h3>

              <ul className="ConditionsSupported_Section_ContentUL">
                <li className="ConditionsSupported_Section_ContentLI">
                  <span className="ConditionsSupported_Section_Content">
                    Classical Homeopathy
                  </span>
                </li>

                <li className="ConditionsSupported_Section_ContentLI">
                  <span className="ConditionsSupported_Section_Content">
                    Holistic Wellness Support
                  </span>
                </li>

                <li className="ConditionsSupported_Section_ContentLI">
                  <span className="ConditionsSupported_Section_Content">
                    Integrative Health Consultation
                  </span>
                </li>

                <li className="ConditionsSupported_Section_ContentLI">
                  <span className="ConditionsSupported_Section_Content">
                    Natural Symptom Support
                  </span>
                </li>

                <li className="ConditionsSupported_Section_ContentLI">
                  <span className="ConditionsSupported_Section_Content">
                    Homeopathic Care in [City/State]
                  </span>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default ServicesConditionsSupported;
